import {
    inject,
    observer
} from 'mobx-react'

import {
    WeaDialog,
    WeaRightMenu
} from 'ecCom'

import FormInfo from './FormInfo';
@inject('hrmSecondaryVerify')
@observer
export default class MainDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            hrmSecondaryVerify
        } = this.props, {
            mainDialog,
            closeDialog,
            buttons,
            style,
            dropMenuDatas,
        } = hrmSecondaryVerify, {
            title,
            visible,
        } = mainDialog;

        return (
            <WeaDialog
                title={title}
                icon="icon-coms-hrm"
                iconBgcolor="#217346"
                visible={visible}
                hasScroll={true}
                onCancel={() => closeDialog()}
                buttons={buttons}
                style={style}
            >
               <WeaRightMenu datas={dropMenuDatas}>
                    {visible && <FormInfo />}
                </WeaRightMenu>
            </WeaDialog>
        )

    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/secondaryVerify/MainDialog.js